import axiosInstance from "@/axios"
import { DataNotFound } from "./DataNotFound"
import { PopupProvider, SnackbarProvider } from "vig-ui-library"
import { useRouter } from "@/Router/router";
import { baseURL } from "@/Utils/environment";
import { companyType } from "@/Utils/environment";
import { Box } from "@mui/material";
// @ts-ignore
import { CompanyType, RequestForm, RequestFormProps } from "request-form-lib";

type OmittedFields = "axiosInstance" |
    "globalErrorBuilder" |
    "openSnackbar" |
    "closeForm" |
    "notificationLinkAddress" |
    "isDealer" |
    "requestModuleUrl" |
    "companyType"

export type RequestFormBuilderProps = Omit<RequestFormProps, OmittedFields> & { popupId: string; closeForm?: () => void }

/// We have wrapped all necessary utilities, hooks, schemas, and components into individual folder. 
/// This was done with the potential future goal of wrapping everything into a module, 
/// as we may want to make it an npm package. This approach will allow us to use the module in other projects.

/// This component is a wrapper for the RequestForm component, adding some additional props to it. 
/// These props include axiosInstance, globalErrorBuilder, and other necessary configurations for the RequestForm package.
export const RequestFormBuilder = (props: RequestFormBuilderProps) => {
    const { openSnackbar } = SnackbarProvider.useSnackbar();

    const { closePopup } = PopupProvider.usePopups();

    const { navigateToAddNewRequest, navigateToPreviewUpdateRequest, navigateToRequests } = useRouter();

    return <Box className="request-form-builder">
        <RequestForm
            {...props}
            axiosInstance={axiosInstance}
            globalErrorBuilder={(title: string, description: string) => <DataNotFound title={title} description={description} />}
            openSnackbar={openSnackbar}
            closeForm={() => {
                if (props.closeForm) {
                    props.closeForm();
                    return;
                }

                if (props.popupId) closePopup(props.popupId);
            }}
            isDealer={true}
            notificationLinkAddress={`${baseURL}/request/detail/{requestId}`}
            requestModuleUrl={baseURL}
            companyType={(companyType as unknown as CompanyType) ?? CompanyType.KOOPERATIVA}
            pageSettings={props.pageSettings}
            openInPage={(requestId?: string, requestType?: number) => {
                if (requestId) {
                    navigateToPreviewUpdateRequest(requestId, requestType?.toString());
                    return;
                }
                if (requestType) navigateToAddNewRequest(requestType?.toString());
            }}
            onClose={props.onClose ?? navigateToRequests}
            onRequestContextLoaded={(name: string) => {
                console.log("onRequestContextLoaded", name);
            }}
        />
    </Box>
}